import React, {createContext, useContext, useImperativeHandle} from 'react';
import {observer} from 'mobx-react-lite';
import {ModalManagerStore} from './modalManagerStore';
import {ModalWrapper} from './ModalWrapper';

export type ModalManagerProviderChildrenProps = ModalManagerContextType;

export type ModalManagerProviderProps = {
	modalManagerStore: ModalManagerStore;
	children:
		| React.ReactNode
		| ((props: ModalManagerProviderChildrenProps) => React.ReactNode);
};

export type ModalManagerContextType = ModalManagerStore;

const StoreContext = createContext<ModalManagerContextType>({} as any);

export const useModalManagerProvider = () =>
	useContext<ModalManagerContextType>(StoreContext);

const ModalManagerProviderPrimitive = React.forwardRef<
	ModalManagerContextType,
	ModalManagerProviderProps
>(({children, modalManagerStore}, ref) => {
	useImperativeHandle(ref, () => modalManagerStore, []);

	return (
		<StoreContext.Provider value={modalManagerStore}>
			{typeof children === 'function' ? children(modalManagerStore) : children}

			{modalManagerStore.items.map((item) => {
				if (!item.shown && !item.open) return null;
				return (
					<ModalWrapper
						key={item.id}
						{...item.rawProps}
						Component={item.Component}
						modalId={item.id}
						modalManagerStore={modalManagerStore}
						open={item.open}
					/>
				);
			})}
		</StoreContext.Provider>
	);
});

export const ModalManagerProvider = observer(ModalManagerProviderPrimitive);
export default ModalManagerProvider;
